<template>
  <q-card class="inhdialog-container">
    <div class="inhdialog-header">
      <h1 class="dialog_name">{{ $t('finances_and_params') }}</h1>
      <q-btn
        flat
        round
        icon="close"
        size="md"
        color="accent"
        :title="$t('close_label')"
        @click="close"
      />
    </div>

    <div class="dialog_content">
      <div class="inner_container">
        <div class="field-group">
          <div class="bold-name">{{ $t('finances') }}</div>
          <div class="file-list">
            <!-- <movement-row v-for="(conn, i) in billInfoContainer?.Connections?.filter(el => el.Descriptor === 1)" :key="'conn_'+i" :el="conn.Income" /> -->
            <table v-if="tmp_connections.length" class="dialog-table">
              <thead>
                <tr>
                  <th style="font-weight: 500; color: black; font-size: 14px; text-transform: unset; vertical-align: bottom;">{{ tmp_connections[0].name }}:</th>
                  <th>Кол-во</th>
                  <th>{{ $t('amount_lower') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, idx) in tmp_connections.slice(1)"
                  :key="'conn_line_' + idx"
                >
                  <td
                    :style="
                      row.header_row ? 'padding: 5px; padding-top: 16px;' : ''
                    "
                  >
                    <div class="row no-wrap">
                      <span style="font-weight: 500"
                        >{{ !row.header_row ? row.idx + "." : "" }}&nbsp;</span
                      >
                      <span style="font-weight: 500">{{
                        row.header_row ? row.name+":" : ""
                      }}</span>
                      <bill-row
                        v-if="!row.header_row && row.connection.bill"
                        :el="row.connection.bill"
                        :bill-type="row.connection.billRowType"
                      />
                      <movement-row
                        v-else-if="!row.header_row && row.connection.movement"
                        :el="row.connection.movement"
                      />
                      <span
                        v-if="!row.header_row && row.connection.percent < 100"
                        style="
                          font-size: 12px;
                          color: #499259;
                          margin-right: 5px;
                        "
                      >
                        {{ row.connection.percent }}%
                      </span>
                      <div
                        v-if="!row.header_row && row.connection.percent < 100"
                        style="display: flex; flex-direction: column"
                      >
                        <payment-progress
                          :narrow="false"
                          :width="50"
                          :percent="Math.round(row.connection.percent)"
                        />
                        <span style="font-size: 12px; font-weight: 500">
                          {{ row.connection.debit }}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td
                    :colspan="row.header_row ? 3 : 1"
                    :style="
                      row.header_row ? 'border-left: 0;' : ''
                    ">
                    <div
                      v-if="!row.header_row && row.connection.movement"
                      :style="`text-align: left; margin-left: 6px;`"
                    >
                      <span
                        v-for="(storagepos, idsx) in row.connection.movement
                          .Items"
                        :key="'stp' + idsx"
                      >
                        {{ storagepos.ItemQuantity }}
                      </span>
                    </div>
                  </td>
                  <td v-if="!row.header_row">
                    {{ row.connection.amount }}
                    <div
                      v-if="row.connection.movement"
                      :style="`text-align: left; margin-left: 6px;`"
                    >
                      <span
                        v-for="(storagepos, idsx) in row.connection.movement
                          .Items"
                        :key="'stp' + idsx"
                      >
                        {{ storagepos.TotalAmount }}
                      </span>
                    </div>
                  </td>
                  <!-- income connection is not removable from the bill info dialog -->
                  <td v-if="!row.header_row" class="cell-actions">
                    <span
                      class="table-remove"
                      :title="$t('remove')"
                    >
                      <app-icon
                        name="close"
                        width="16px"
                        color="#979797"
                        hover-color="#616161"
                        cursor="pointer"
                      />
                      <q-menu>
                        <q-card>
                          <q-card-section class="row items-center">
                            <q-avatar
                              icon="delete"
                              size="md"
                              color="grey"
                              text-color="white"
                            />
                            <span class="q-ml-sm">
                              {{ $t("sure_delete") }}
                            </span>
                          </q-card-section>

                          <q-card-actions align="right">
                            <q-btn
                              size="sm"
                              flat
                              :label="$t('cancel')"
                              color="dark"
                              :ref="'cancelbtn' + idx"
                              v-close-popup
                            />
                            <q-btn
                              size="sm"
                              flat
                              :label="$t('remove')"
                              autofocus
                              color="dark"
                              :ref="'okbtn' + idx"
                              v-close-popup
                            />
                            <!-- @click="remove(idx)" -->
                          </q-card-actions>
                        </q-card>
                      </q-menu>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="field-group">
          <div class="bold-name">{{ $t('parameters') }}</div>
          <table
            class="dialog-table"
            v-for="(params, pid) in innerModel.Parameters"
            :key="'ptable_' + pid"
            :ref="
              (el) => {
                triggerEls[pid] = el;
              }
            "
          >
            <parameter-inline
              v-if="triggerEls[pid]"
              :is-root="true"
              editable
              is-table
              :id="'project-param-' + pid"
              v-model="parameters_model[pid]"
              :token-styles="tokenStyles"
              :show-custom="false"
              :context-trigger="triggerEls[pid]"
              :create-mode="false"
            >
            </parameter-inline>
          </table>
        </div>
      </div>
    </div>
    <div class="dialog-button">
      <div class="row no-wrap justify-end">
        <q-btn :label="$t('cancel_short')" no-caps flat @click="close" />
      </div>
    </div>
  </q-card>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-facing-decorator";
import { QBtn } from "quasar";
// import ParameterInline from './ParameterInline.vue';
import { reactive } from "vue";
import _ from "lodash";
import { parameterStore } from "../../../store/parameters/parameter-store";
import ConnectionsTableHtml from "./ConnectionsTableHtml.vue";
import {
  BillLinkedBase,
  BillWithManyLinks,
  BillWithOneLink,
  StorageItemMovementInFinances,
} from "../../../models/interfaces/finances/finance-models";
import { BillLinkedTypeDescriptor, BillType } from "../../../models/etc/types";
import {
  BillRowProps,
  ConnectionLine,
} from "../../../store/heartbeat-workers/useEntityStore";
import PaymentProgress from "./storageshared/PaymentProgress.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

@Component({
  name: "ProjectDataComponent",
  emits: ["close"],
  components: {
    QBtn,
    ConnectionsTableHtml,
    PaymentProgress,
    AppIcon,
  },
})
export default class ProjectDataComponent extends Vue {
  @Prop({ required: true, default: 0 }) readonly projectId!: number;
  
  // dynamic item refs
  triggerEls: HTMLDivElement[] = reactive([]);
  innerModel: any = reactive({});
  tokenStyles: Record<string, string> = {
    artikul: "tok--link",
    name: "tok--base",
    class: "tok--muted",
  };

  // stores import
  parameter_store: any | undefined = undefined;
  tmp_connections: {
    idx: number;
    header_row: boolean;
    name: string;
    connection?: ConnectionLine;
  }[] = reactive([]);

  parameters_model: any[] = reactive([]);

  created() {
    this.parameter_store = parameterStore();
  }

  async mounted() {
    this.innerModel = reactive(await this.parameter_store.getProject(this.projectId));
    this.parameters_model = reactive(
      this.innerModel.Parameters.map((pm: any) => [pm]),
    );

    // @ts-ignore
    if (this.innerModel.Bills || this.innerModel.StorageItemExpenditureMovements) {
      this.tmp_connections = reactive([]);

      const allConnections = (this.innerModel.Bills as BillLinkedBase[]).map(
        (conn: BillLinkedBase) => {
          if (conn.Descriptor === BillLinkedTypeDescriptor.BillWithOneLink) {
            const c = conn as BillWithOneLink;
            return {
              conn_id: 0,
              percent: c.PayedPercent,
              amount: c.TotalAmount,
              debit: c.PayedAmount,
              movement: undefined,
              billRowType: BillRowProps.BillLinkedBase,
              bill: c,
              canEditAmounts: false,
              canEditDebits: false,
              canBeDeleted: false,
            } as ConnectionLine;
          } else if (
            conn.Descriptor === BillLinkedTypeDescriptor.BillWithManyLinks
          ) {
            const c = conn as BillWithManyLinks;
            return {
              conn_id: 0,
              percent: c.LinkPercent,
              amount: c.LinkAmount,
              debit: c.PayedAmount,
              billRowType: BillRowProps.BillLinkedBase,
              bill: c,
              canEditAmounts: false,
              canEditDebits: false,
              canBeDeleted: false,
            } as ConnectionLine;
          }
        },
      );

      const incoming = allConnections.filter(
        (conn) => conn?.bill?.Type === BillType.Incoming,
      );
      const outgoing = allConnections.filter(
        (conn) => conn?.bill?.Type === BillType.Outgoing,
      );
      const movements = (this.innerModel.StorageItemExpenditureMovements as StorageItemMovementInFinances[]).map(
        (conn: StorageItemMovementInFinances) => {
          const sum = +(conn.Items ?? []).reduce(
            (s, a) => s + (a.TotalAmount ? +a.TotalAmount : 0),
            0
          );
            return {
              conn_id: 0,
              percent: 100,
              amount: sum,
              debit: 0,
              billRowType: BillRowProps.BillLinkedBase,
              movement: conn,
              canEditAmounts: false,
              canEditDebits: false,
              canBeDeleted: false,
            } as ConnectionLine;
        },
      );

      // table composition
      if (movements.length) {
        this.tmp_connections.push({
          header_row: true,
          name: this.$t('expenses_transfers'),
          connection: undefined,
          idx: 0
        });

        movements.forEach((move, move_i) => {
          this.tmp_connections.push({
            header_row: false,
            name: '',
            connection: move,
            idx: move_i+1
          });
        })
      }

      if (incoming.length) {
        this.tmp_connections.push({
          header_row: true,
          name: "Входящие",
          connection: undefined,
          idx: 0
        });

        incoming.forEach((inc, inc_i) => {
          this.tmp_connections.push({
            header_row: false,
            name: '',
            connection: inc,
            idx: movements.length + inc_i + 1
          });
        })
      }

      if (outgoing.length) {
        this.tmp_connections.push({
          header_row: true,
          name: "Исходящие",
          connection: undefined,
          idx: 0
        });

        outgoing.forEach((outg, out_i) => {
          this.tmp_connections.push({
            header_row: false,
            name: '',
            connection: outg,
            idx: out_i + 1,
          });
        })
      }
    }
  }

  close() {
    this.$emit("close", null);
  }
}
</script>

<style lang="scss" scoped>
.table-remove {
  display: inline-flex;
  line-height: 0;
  vertical-align: middle;
  cursor: pointer;
}
</style>
